/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import { Query } from 'react-apollo';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import gql from 'graphql-tag';
import { object, shape, string } from 'prop-types';
import mbpLogger from 'mbp-logger';
import { compose } from 'recompose';
import SeoArticlesBlock from './SeoArticlesBlock';
import { GRAPHQL_ENV } from '../../../gql';
import * as app from '../../../../state/ducks/App';
import withPageView from '../../../helpers/tracking/hocs/withPageView';
import { coreBrowsingPageViewSuccessTest } from '../../../helpers/tracking/common/commonTrackingHelpers';
import { setLocale } from '../../../../state/ducks/Member/ducks/Auth/helper/helper';
import { getSSRDeviceType } from '../../../../state/ducks/App/App-Selectors';

const brandSelectors = app?.ducks?.brand?.selectors;

const SeoArticlesPage = ({ brand, page, ssrDeviceType }) => {
    const Seo_Articles_PAGE_QUERY = gql`
            query SeoArticlesPageQuery {
                findContentPage(brand: "${brand['domain-name']}", url: "${page?.path}", contentType: "${page?.contentType}", environment: "${GRAPHQL_ENV}", locale: "${setLocale()}") {
                    content
                }
            }
        `;
    return (
        <Query query={Seo_Articles_PAGE_QUERY}>
            {({ loading, error, data }) => {
                if (loading) {
                    return  <div style={{ height: '80vh' }} />; // prevent header and footer from snapping together
                }

                if (error) {
                    mbpLogger.logError({
                        query: Seo_Articles_PAGE_QUERY,
                        component: 'SeoArticlesPage.js',
                        message: 'Error loading data from Graphql',
                        env: GRAPHQL_ENV,
                        error,
                    });
                    return null;
                }

                if (!data) {
                    mbpLogger.logWarning({
                        query: Seo_Articles_PAGE_QUERY,
                        component: 'SeoArticlesPage.js',
                        message: 'No data returned for query',
                        env: GRAPHQL_ENV,
                    });
                    return null;
                }

                const blocks = data?.findContentPage?.content?.entries[0] || null;
                if (blocks !== null) {
                    return (
                        <>
                            <SeoArticlesBlock data={blocks} brand={brand} ssrDeviceType={ssrDeviceType} />
                        </>
                    );
                }
                return null;
            }}
        </Query>
    );
};

SeoArticlesPage.propTypes = {
    brand: object.isRequired,
    page: shape({
        contentType: string.isRequired,
        path: string.isRequired,
    }).isRequired,
    ssrDeviceType: string.isRequired,
};
const mapStateToProps = (state) => ({
    brand: brandSelectors?.getBrand(state),
    ssrDeviceType: getSSRDeviceType(state),
});

const enhance = compose(
    withPageView({
        pageViewSuccessTest: coreBrowsingPageViewSuccessTest,
    }),
    withRouter,
    connect(mapStateToProps),
);

export default enhance(SeoArticlesPage);
